import { ResolveSwapOrReturn } from './ResolveSwapOrReturn'

export default ResolveSwapOrReturn
